const multicolumnList = document.querySelector('.multicolumn-list');
const fakeThumb = document.querySelector('.fake-thumb');
const fakeScrollbar = document.querySelector('.fake-scrollbar');

// Sync the fake scrollbar thumb with the actual scroll position
multicolumnList.addEventListener('scroll', () => {
    const scrollPercentage = multicolumnList.scrollLeft / (multicolumnList.scrollWidth - multicolumnList.clientWidth);
    const maxThumbOffset = fakeScrollbar.clientWidth - fakeThumb.offsetWidth; // Adjusted for the fake scrollbar's width
    fakeThumb.style.left = scrollPercentage * maxThumbOffset + 'px';
});

// Dragging functionality for the fake scrollbar
let isDragging = false;
let startX;
let startLeft;

fakeThumb.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX;
    startLeft = parseInt(window.getComputedStyle(fakeThumb).left, 10);
    e.preventDefault();
});

document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const deltaX = e.pageX - startX;
    let newLeft = startLeft + deltaX;

    // Boundaries for the fake scrollbar thumb
    const maxLeft = fakeScrollbar.clientWidth - fakeThumb.offsetWidth;
    if (newLeft < 0) newLeft = 0;
    if (newLeft > maxLeft) newLeft = maxLeft;

    fakeThumb.style.left = newLeft + 'px';

    // Calculate the corresponding scroll position
    const scrollPercentage = newLeft / maxLeft;
    multicolumnList.scrollLeft = scrollPercentage * (multicolumnList.scrollWidth - multicolumnList.clientWidth);
});

document.addEventListener('mouseup', () => {
    isDragging = false;
});
